import { combineEpics } from 'redux-observable';
import { createServerEpic } from './_epic/createServer.epic';
import { updateServerEpic } from './_epic/updateServer.epic';
import { removeServerEpic } from './_epic/removeServer.epic';
import { loadServerListEpic } from './_epic/loadServerList.epic';
import { loadServerEpic } from './_epic/loadServer.epic';
import { startServerProcessingEpic } from './_epic/startServerProcessing.epic';
import { endServerProcessingEpic } from './_epic/endServerProcessing.epic';
import { generateServerSecretEpic } from './_epic/generateServerSecret.epic';
import { createServerStreamEpic } from './_epic/createServerStream.epic';
import { updateServerStreamEpic } from './_epic/updateServerStream.epic';
import { removeServerStreamEpic } from './_epic/removeServerStream.epic';

export const serverEpic = combineEpics(
  createServerEpic,
  updateServerEpic,
  removeServerEpic,
  loadServerListEpic,
  loadServerEpic,
  startServerProcessingEpic,
  endServerProcessingEpic,
  generateServerSecretEpic,
  createServerStreamEpic,
  updateServerStreamEpic,
  removeServerStreamEpic,
);
